module.exports = __webpack_public_path__ + "static/img/authentication.fae6cd58.png";